import React from 'react';

import { Box, H5, Text, Icon, Row, Col, Link } from '@atoms';

import { ErrorPageBoxProps } from '../error-boxes';

import classes from './error-box.module.scss';

export const ErrorBox = ({
  iconType,
  titleId,
  subtitleId,
  linkText,
  pageLink,
}: ErrorPageBoxProps) => {
  return (
    <Col lg={6} key={titleId}>
      <Link {...pageLink}>
        <Box className={classes.container}>
          {/* TOP SECTION */}
          <div className={classes.content}>
            <Row justify="center">
              <Icon icon={iconType} className={classes.icon} />
            </Row>
            <H5 message={{ id: titleId }} textAlign="center" />
            <Text
              type="regular"
              message={{ id: subtitleId }}
              textAlign="center"
              color="slate_gray"
            />
          </div>

          {/* BOTTOM LINK SECTION*/}
          <div className={classes.linkSection}>
            <Text
              type="reduced"
              message={{ id: linkText }}
              fontWeight={600}
              color="inherit"
              margin={0}
            />
            <Icon icon="chevron-right" className={classes.icon} />
          </div>
        </Box>
      </Link>
    </Col>
  );
};
